export default __webpack_public_path__ + "static/media/myhealthilyLogo.3186fd60.svg";